const WebsocketEmitters = {
  PONG: 'PONG',
  AUTH: 'AUTH',
  AUTH_REQUIRED: 'AUTH_REQUIRED',
  AUTH_OK: 'AUTH_OK',
  AUTH_FAILURE: 'AUTH_FAILURE',
  REGISTRATION_REQUIRED: 'REGISTRATION_REQUIRED',
  BALANCE_UPDATED: 'BALANCE_UPDATED',
  TASKS_UPDATED: 'TASKS_UPDATED',
  TASK_PROGRESS: 'TASK_PROGRESS',
  TASK_COMPLETE: 'TASK_COMPLETE',
  LEVEL_UPGRADE: 'LEVEL_UPGRADE',
  REFERRAL_REWARD: 'REFERRAL_REWARD',
  USER_REMOVED_FROM_GROUP: 'USER_REMOVED_FROM_GROUP',
  CHANGE_GROUP_NAME: 'CHANGE_GROUP_NAME',
  ADD_FUND: 'ADD_FUND',
  VIP_ACTIVATED: 'VIP_ACTIVATED',
  BOOST_ACTIVATED: 'BOOST_ACTIVATED',
  BUY_ARENA_OFFER: 'BUY_ARENA_OFFER',
  THANK_YOU_WINDOW_REWARD: 'THANK_YOU_WINDOW_REWARD',
  PAID_PLAN: 'BUY_LINE_REWARDS',
  PRODUCT_OF_DAY_UPDATED: 'PRODUCT_OF_DAY_UPDATED',
  UPDATE_BOARD_GAME_ENERGY: 'UPDATE_BOARD_GAME_ENERGY',
  LOTTERY_TICKET_DRAWN: 'LOTTERY_TICKET_DRAWN',
  LOTTERY_INCENTIVE: 'LOTTERY_INCENTIVE',
  FIRST_LOTTERY_TICKET: 'FIRST_LOTTERY_TICKET',
  OPEN_CONTRACT_PLUS: 'OPEN_CONTRACT_PLUS',
  BINGO_COMPLETION: 'BINGO_COMPLETION',
  SCRATCH_TICKET_BOUGHT: 'SCRATCH_TICKET_BOUGHT',
  SCRATCH_EVENT_END: 'SCRATCH_EVENT_END',
} as const;

export { WebsocketEmitters };
